import React, { Fragment, useState } from "react";
import { toast } from "react-toastify";
import { handleError, hasAValue } from "../../../utils/SharedFunctions";
import { addMandateNumber } from "../../../Api/ApiCalls";
import CsvFileUploader from "../../../components/Common/CsvFileUploader";

export default function MandateNumber() {
  const [csv, setCsvFile] = useState();

  const submitFile = async () => {
    if (hasAValue(csv)) {
      const formData = new FormData();
      formData.append("file", csv);
      addMandateNumber(formData)
        .then((success) => {
          toast.success("Mandate Numbers received successfully");
          setCsvFile(undefined);
        })
        .catch((error) => {
          handleError(error);
        });
    } else {
      toast.error("File is required");
    }
  };

  return (
    <>
      <Fragment>
        <div className="row justify-content-center">
          <div className="col-xl-12 col-xxl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Mandate Numbers</h4>
              </div>
              <div className="card-body">
                <section>
                  <div className="row justify-content-center">
                    <CsvFileUploader
                        label="Upload CSV File Here"
                        exampleLink="/mandate_numbers_template.csv"
                        onValidFile={(file) => setCsvFile(file)}
                    />
                  </div>
                </section>
                <div className="text-end toolbar toolbar-bottom p-2">
                  <button
                      className="btn btn-secondary sw-btn-next ms-1"
                    onClick={submitFile}
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    </>
  );
}
